import { Grid, IconButton } from '@material-ui/core';
import { logo_dof } from 'components/base/images';
import MuiButton from 'components/common/button/MuiButton';
import { ENV_MODE_DEV } from 'lib/setting';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { pageUrl } from 'lib/mapper';

interface AuthLayoutProps {
  containerWidth?: string | number;
  title: React.ReactNode | string;
  children: React.ReactNode | string;
  devContent?: React.ReactNode;
  button?: React.ReactNode;
  buttonText?: React.ReactNode | string;
  linkContent?: React.ReactNode;
  isValidForm: boolean;
  onSubmit: () => void;
}

function AuthLayout({
  containerWidth,
  title,
  children,
  devContent,
  button,
  onSubmit,
  buttonText,
  linkContent,
  isValidForm,
}: AuthLayoutProps) {
  const history = useHistory();
  const location = history.location;
  const { pathname } = location as { pathname: string; search: string; state: any };
  const isPasswordReset = pathname === pageUrl.auth.passwordReset || false;
  const isSingInPage = pathname === pageUrl.auth.signIn;
  const handleClickBack = () => {
    console.log('HDS] handleClickBack _____ ', isSingInPage);
    if (isSingInPage) {
      history.push(pageUrl.home);
    } else {
      history.push(pageUrl.auth.signIn);
    }
  };

  return (
    <StyledAuthLayout data-component-name="AuthLayout" containerWidth={containerWidth}>
      {ENV_MODE_DEV && devContent && <div className="dev__insert">{devContent}</div>}
      {!isPasswordReset && (
        <IconButton
          aria-label="cancel modal"
          className="authLayout__close_btn"
          // onClick={() => history.push(pageUrl.auth.signIn)}
          onClick={() => handleClickBack()}
        >
          <KeyboardBackspaceIcon
            htmlColor="inherit"
            fontSize="large"
            className="authLayout__close_icon"
          />
        </IconButton>
      )}

      <Grid container className="authLayout__form_container">
        <Grid item xs={12} className="authLayout__form_header">
          <div className="authLayout__logo_box">
            <img src={logo_dof} alt="dof" className="authLayout__logo" />
          </div>
          <h1 className="authLayout__title">{title}</h1>
        </Grid>

        <Grid container item className="authLayout__form_body">
          {children}
        </Grid>

        <Grid item xs={12} className="authLayout__form_footer">
          <div className="authLayout__form_submit_box">
            {button ? (
              { button }
            ) : (
              <MuiButton
                variant="contained"
                color="primary"
                fullWidth
                disableElevation
                disabled={!isValidForm}
                className="submit__btn"
                onClick={onSubmit}
                aria-label="submit"
              >
                {buttonText}
              </MuiButton>
            )}
          </div>

          {linkContent && <div className="authLayout__link_box">{linkContent}</div>}
        </Grid>
      </Grid>
    </StyledAuthLayout>
  );
}

export default React.memo(AuthLayout);

const StyledAuthLayout = styled.section<{ containerWidth?: string | number }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #f4f7fa;

  .dev__insert {
    position: absolute;
    top: 50px;
    left: 50%;
    transform: translate(-50%, 0%);
    & > *:not(:first-child) {
      margin-left: 10px;
    }
  }
  .authLayout__close_btn {
    position: absolute;
    top: 50px;
    /* right: 50px; */
    left: 50px;
  }

  .authLayout__form_container {
    max-width: 360px;
    max-width: ${({ containerWidth }) =>
      containerWidth && typeof containerWidth === 'string'
        ? containerWidth
        : containerWidth && containerWidth + 'px'};
    margin: 5px;
    padding: 25px;
    background-color: white;
    box-shadow: 0 1px 20px 0 rgb(69 90 100 / 8%);
    .authLayout__form_header {
      .authLayout__logo_box {
        margin-bottom: 20px;
        text-align: center;
        img {
          width: 128px;
        }
      }
      .authLayout__title {
        margin-bottom: 50px;
        font-size: 26px;
        color: #333;
        text-align: center;
      }
    }

    .authLayout__form_body {
      .authLayout__form_description {
        font-size: 14px;
        line-height: 1.3;
      }

      & > .input__label_box:not(:first-child) {
        margin-top: 15px;
      }
      .authLayout__form_row {
        &:not(:first-child) {
          margin-top: 15px;
        }
      }
    }

    .authLayout__form_footer {
      .authLayout__form_submit_box {
        margin-bottom: 12px;
        margin-top: 55px;
        text-align: center;
        .submit__btn {
          font-size: 16px;
        }
      }
      .authLayout__link_box {
        text-align: center;
        .authLayout__link_row {
          margin-top: 20px;
          font-size: 13px;
          &:not(:first-child) {
            margin-left: 5px;
          }
        }
      }
    }
  }

  .link__box {
    display: block;
    margin-top: 20px;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
  }
`;
